



















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"

/**
 * @status stable
 * @published 5.8.2
 * @changelog 5.8.2 Published.
 */
@Component({
    components: {JdhSneakPeek}
})
export default class JdsReactionBadge extends Vue {
    @Ref() anchorEl!: HTMLElement
    @Prop() type!: string
    @Prop() value!: number
    showTooltip = false

}
